import { Component } from '@angular/core';
import { MaskService } from '../mask.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mpp-mask-setting-dialog',
  templateUrl: './mask-setting-dialog.component.html',
  styleUrls: ['./mask-setting-dialog.component.scss'],
  standalone: false,
})
export class MaskSettingDialogComponent {
  private fallbackAttempted = false;

  constructor(
    public maskService: MaskService,
    public languageService: LanguageService,
  ) {
    let current2LettersLanguage = this.languageService.getCurrent2LettersLanguage();
    this.maskService.maskMp4Url = `${environment.endpoints.staticMyair}/v1/mask_setup/airfit_f40/${current2LettersLanguage}/airfit_f40_mask_optimization.mp4`;
  }

  onVideoError(): void {
    if (!this.fallbackAttempted) {
      this.fallbackAttempted = true;
      const fallbackLang = environment.isEU ? 'en-GB' : 'en';
      this.maskService.maskMp4Url = `${environment.endpoints.staticMyair}/v1/mask_setup/airfit_f40/${fallbackLang}/airfit_f40_mask_optimization.mp4`;
    }
  }

  close(): void {
    this.maskService.maskSettingDialog.close();
  }
}
